import MinimalDatePicker from './MinimalDatePicker';

// Wrapper to maintain backward compatibility
const DatePicker = (props) => {
  return <MinimalDatePicker {...props} />;
};

export default DatePicker;
